export * from './home';
export * from './legalpages';
export * from './pointsummary';
export * from './salesclaim';
export * from './couponclaim';
export * from './invoiceclaim';
export * from './goalquest';
export * from './quiz';
export * from './game';
export * from './_layout';
export * from './myperformance';
export * from './myawards';
export * from './embeddedreport';
export * from './messagepage';
export * from './questionpage';
export * from './error';
export * from './contentpage';
export * from './league';
export * from './hubpage';
export * from './accounts';
export * from './tabview';
export * from './communication';
export * from './registrationapproval';